import "./third_party/vicowa-web-components/dist/vicowa-image-container/vicowa-image-container.js";
import "./content/mandyrodney-home.js";
import features from "./third_party/vicowa-web-components/dist/utilities/featureDetect.js";

if (features.webp) {
	document.body.classList.add("webp");
}
